enum MD_FEATURE {
	CONTAINER = 'CONTAINER',
	EMOTICON  = 'EMOTICON',
	HIGHLIGHT = 'HIGHLIGHT',
	HTML      = 'HTML',
	IMAGE     = 'IMAGE',
	INDEX     = 'INDEX',
	LINK      = 'LINK',
	SPOILER   = 'SPOILER',
}

export default MD_FEATURE;
